var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcImageOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "h5yjaciioa",
    d: "M3.333 3.333c-.91 0-1.666.756-1.666 1.667v10c0 .91.755 1.667 1.666 1.667h13.334c.91 0 1.666-.756 1.666-1.667V5c0-.91-.755-1.667-1.666-1.667H3.333zm0 1.667h13.334v10H3.333V5zm5 1.667c-.46 0-.833.373-.833.833 0 .46.373.833.833.833.46 0 .834-.373.834-.833 0-.46-.373-.833-.834-.833zm3.75 2.5L9.167 12.5l-2.084-2.083-2.269 2.916h10.394l-3.125-4.166z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rnt7zn0whb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h5yjaciioa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#h5yjaciioa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4F5964",
    mask: "url(#rnt7zn0whb)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "color-fill",
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImageOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-image-outline.8dc7cd22.svg";
export { ForwardRef as ReactComponent };